import {
    required,
    concatFailure,
    shape,
    greaterThan
  } from '@totalsoft/pure-validations';
  
  export const financialProductWarrantyValidator = shape({
        warrantyTypeId: required,
        quantityTypeId: required,
        quantity: concatFailure(greaterThan(0), required),
        mandatory: required
    });